import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./components/dashboard/dashboard";
import "./index.css";
import ClientsList from "./components/dashboard/clientsList";
import Login from "./components/login";
import "./App.css";
import { StoresProvider } from "./stores";
import adminAuthService from "./services/authService";

function App() {
  return (
    <StoresProvider>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </StoresProvider>
  );
}

function Main() {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);

  // Initialize auth service on mount and check authentication
  useEffect(() => {
    adminAuthService.initializeAuth();
    const authStatus = adminAuthService.isAuthenticated();
    setIsAuthenticated(authStatus);
    console.log('App authentication check:', authStatus); // Debug log
    console.log('Current user:', adminAuthService.getCurrentUser()); // Debug log
    console.log('Current token:', adminAuthService.getToken()); // Debug log
  }, []);

  useEffect(() => {
    // Listen for cross-domain logout events
    const handleCrossDomainLogout = () => {
      adminAuthService.clearAuth();
      // Force page reload to redirect to login
      window.location.href = '/login';
    };

    const handleStorageChange = (e) => {
      // Handle localStorage changes from other tabs
      if (e.key === 'awaken_shared_token' && !e.newValue) {
        // Token was cleared, logout
        adminAuthService.clearAuth();
        window.location.href = '/login';
      }
    };

    window.addEventListener('crossDomainLogout', handleCrossDomainLogout);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('crossDomainLogout', handleCrossDomainLogout);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <div>
      <Routes>
        {isAuthenticated ? (
          <>
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/clients" element={<ClientsList />} />
            <Route path="/about" element={require('./components/about.jsx').default ? require('./components/about.jsx').default : require('./components/about.jsx')} />
            <Route path="/faq" element={require('./components/faq.jsx').default ? require('./components/faq.jsx').default : require('./components/faq.jsx')} />
            <Route path="/contact" element={require('./components/contact.jsx').default ? require('./components/contact.jsx').default : require('./components/contact.jsx')} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>
    </div>
  );
}

export default App;
